import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';

@Component({
    selector: 'pax-header-mobile',
    standalone: true,
    imports: [RouterLink, LucideAngularModule],
    styleUrls: ['./header-mobile.component.scss'],
    templateUrl: './header-mobile.component.html',
})
export class HeaderMobileComponent {
    readonly isMenuOpen = input(false);
}
